const Section = ({ title, children }) => (
  <section className="space-y-2">
    <h2 className="font-display font-semibold text-xl text-[#222]">{title}</h2>
    <div className="text-[#444] space-y-2 text-[15px] leading-relaxed">{children}</div>
  </section>
);

export default function Privacy() {
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-testid="privacy-page">
      <h1 className="text-3xl sm:text-4xl font-display font-bold mb-2">Privacy Policy</h1>
      <p className="text-[#717171] mb-8">Last updated {new Date().getFullYear()} · Ixitrip</p>

      <div className="space-y-8">
        <Section title="1. Information we collect">
          <p>We collect information you provide when you create an account or make a booking — such as your name, email, phone number, and booking details. We also collect limited technical data (device and usage information) to operate and improve the service. Payment card details are handled directly by our payment partner (Razorpay) and are not stored on Ixitrip servers.</p>
        </Section>

        <Section title="2. How we use your information">
          <p>We use your information to process bookings and payments, connect travelers with hosts, send booking confirmations and service updates, provide customer support, prevent fraud, and comply with legal obligations.</p>
        </Section>

        <Section title="3. Sharing your information">
          <p>To fulfill a booking, we share necessary details (such as your name and contact number) with the relevant host or service provider. We share payment information with our payment processor. We do not sell your personal data. We may disclose information where required by law.</p>
        </Section>

        <Section title="4. Cookies">
          <p>We use essential cookies to keep you signed in and remember your preferences. You can control cookies through your browser settings, though some features may not work without them.</p>
        </Section>

        <Section title="5. Data retention &amp; security">
          <p>We retain your information for as long as your account is active or as needed to provide the service and meet legal requirements. We use industry-standard measures, including encryption in transit, to protect your data.</p>
        </Section>

        <Section title="6. Your rights">
          <p>You may access, correct, or request deletion of your personal information, and opt out of non-essential communications, by contacting us. We will respond in line with applicable law.</p>
        </Section>

        <Section title="7. Contact">
          <p>For privacy questions or requests, email <a href="mailto:customerservice@ixitrip.com" className="text-[#FF385C] font-medium">customerservice@ixitrip.com</a>.</p>
        </Section>
      </div>
    </div>
  );
}
